import axios from 'axios';
import { IS_LOADING, BANNER_LIST_SUCCESS, BANNER_LIST_ERROR, BANNER_UPDATE_SUCCESS, BANNER_UPDATE_ERROR } from './Type';
import { baseUrlPostGres } from '../constant';
import { apiHeader } from './ApiHeader';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import HandleError from '../HandleError';
import { apiVersion } from 'src/utils/apiVersion';

export const GetBannerListAction = () => async (dispatch) => {
    dispatch({ type: IS_LOADING })
    await axios
        .get(`${baseUrlPostGres()}/admin/${apiVersion.v1}/banner/list`, {
            headers: apiHeader()
        })
        .then(response => {
            dispatch({
                type: BANNER_LIST_SUCCESS,
                payload: response
            })
        })
        .catch(errors => {
            HandleError(errors.response.data)
            dispatch({
                type: BANNER_LIST_ERROR,
                payload: errors
            })
        })
}

export const ResetBannerListAction = () => async (dispatch) => {
    dispatch({
        type: BANNER_LIST_SUCCESS,
        payload: {}
    })
}


export const UpdateBannerAction = (data) => async (dispatch) => {
    dispatch({ type: IS_LOADING })
    await axios
        .post(`${baseUrlPostGres()}/admin/${apiVersion.v1}/banner/edit`, data, {
            headers: apiHeader()
        })
        .then(response => {
            dispatch({
                type: BANNER_UPDATE_SUCCESS,
                payload: response
            })
        })
        .catch(errors => {
            HandleError(errors.response.data)
            dispatch({
                type: BANNER_UPDATE_ERROR,
                payload: errors
            })
        })
}

export const ResetUpdateBannerAction = () => async (dispatch) => {
    dispatch({
        type: BANNER_UPDATE_SUCCESS,
        payload: {}
    })
}